import { message } from 'antd';
import { PopupType, PopupDescription } from 'store/popup/util';
import { MessageType } from 'antd/lib/message';
import { t } from 'helpers/i18n';

class PopupHelper {
  hidePopupFunc?: MessageType;

  showPopup(desc: PopupDescription) {
    if (desc.visible) {
      switch (desc.popupType) {
        case PopupType.Success:
          this.hidePopupFunc = message.success(
            desc.message ? desc.message : t('Success')
          );
          break;
        case PopupType.Error:
          this.hidePopupFunc = message.error(
            desc.message ? desc.message : t('Error')
          );
          break;
        case PopupType.Warning:
          this.hidePopupFunc = message.warning(
            desc.message ? desc.message : t('Warning')
          );
          break;
        case PopupType.Loading:
          this.hidePopupFunc = message.loading(
            desc.message ? desc.message : t('Processing')
          );
          break;
        default:
          return;
      }
    } else if (this.hidePopupFunc) {
      this.hidePopupFunc();
    }
  }
}

export default new PopupHelper();
